<!-- @veltra/icons generated sha256:d13417ece0752084 gen:8 source:src/svg/normal/picture-rounded.svg -->
<script setup lang="ts">
defineOptions({ name: 'PictureRounded' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3 14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 3v7.293l2.295-2.295a1.007 1.007 0 0 1 1.42.01L11.706 13H13V3zm9 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5.295 9.413 3 11.707V13h7.293L6.695 9.402a.984.984 0 0 0-1.4.01"
    />
  </svg>
</template>
